// Single source of truth for the Job Offer Income Affidavit deep-link path.
// Used by `App.tsx` for route registration and by the ClientScreen coach UI
// when constructing the link to share with a student.

export const JOB_OFFER_INCOME_AFFIDAVIT_PATH_PREFIX = "/affidavits" as const;

export const JOB_OFFER_INCOME_AFFIDAVIT_ROUTE_PATTERN =
  `${JOB_OFFER_INCOME_AFFIDAVIT_PATH_PREFIX}/:outcomeId` as const;

export function buildJobOfferIncomeAffidavitDeepLink(outcomeId: string): string {
  return `${window.location.origin}${JOB_OFFER_INCOME_AFFIDAVIT_PATH_PREFIX}/${outcomeId}`;
}
